import { render, staticRenderFns } from "./thawingRecord.vue?vue&type=template&id=953a5a7a&scoped=true"
import script from "./thawingRecord.vue?vue&type=script&lang=js"
export * from "./thawingRecord.vue?vue&type=script&lang=js"
import style0 from "./thawingRecord.vue?vue&type=style&index=0&id=953a5a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953a5a7a",
  null
  
)

export default component.exports